<script lang="ts">
      import BlockWidth from "../blocks/BlockWidth.svelte"
import GridFeedHero from "./GridFeedHero.svelte"

	  

	let { block } = $props()

	let _block = block.page.filter( p => typeof p.populate.value != "number")
</script>


<BlockWidth width={block.width ?? "normal"}>

	<div class="grid-block grid { block.grid == "small" ? "grid-cols-8" : "grid-cols-2 lg:grid-cols-4" } gap-4" style="">
		{#each _block as item, i} 
		<GridFeedHero gridItem={item}></GridFeedHero>
		{/each}
	</div>
</BlockWidth>


<style lang="postcss">
	.grid-block {
		/*grid-template-rows: repeat(auto-fill, 1fr);*/
		grid-auto-rows: 1fr;
}
</style>
